module.exports = __webpack_public_path__ + "img/setting_11.39ec8c95.svg";